import React, { useState } from "react";
import Societies from "../../component/Societies/Societies";
import banner from "../../asset/Unapproved banner.png";
import { useGetUnapprovedSocietiesQuery } from "../../Redux/getApi";
import { useDebounce } from "use-debounce";

const UnapprovedSocieties = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [debouncedSearch] = useDebounce(search, 1500);

  const { data, error, isLoading, isFetching } = useGetUnapprovedSocietiesQuery(
    {
      page,
      search: debouncedSearch,
    },
  );
  const unapprovedSocieties = data?.societies;
  const totalPages = data?.totalPages;
  const currentPage = data?.currentPage;
  const totalSocieties = data?.totalSocieties;

  return (
    <div>
      <Societies
        societies={unapprovedSocieties}
        bgColor="#DDEBF7"
        color="#008CFF"
        banner={banner}
        name="Unapproved Housing Societies"
        error={error}
        isLoading={isLoading}
        isFetching={isFetching}
        totalPages={totalPages}
        currentPage={currentPage}
        search={search}
        setSearch={setSearch}
        page={page}
        setPage={setPage}
        societyStatus="unapproved"
        totalSocieties={totalSocieties}
      />
    </div>
  );
};

export default UnapprovedSocieties;
